enum EducationEnum {
    ELEMENTARY = "ELEMENTARY",
    SECONDARY = "SECONDARY",
    SECONDARY_VOCATIONAL = "SECONDARY_VOCATIONAL",
    SECONDARY_APPRENTICESHIP = "SECONDARY_APPRENTICESHIP",
    TERTIARY = "TERTIARY"
}

export default EducationEnum;
